import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionTo?: string;
  compact?: boolean;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
  actionTo,
  compact = false,
}: EmptyStateProps) {
  return (
    <div
      className={`flex w-full flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-5 text-center ${
        compact ? "py-10" : "py-16 md:py-20"
      }`}
    >
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-700">
        <i className={`${icon} text-2xl`}></i>
      </span>
      <p className="mt-4 text-base font-medium text-foreground-900">{title}</p>
      {description && (
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
        </button>
      )}
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="mt-5 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
        </Link>
      )}
    </div>
  );
}